// extracted by mini-css-extract-plugin
export default {"container":"info-card_container__Zp2n+","image":"info-card_image__EbGO7","text":"info-card_text__eiuoU","description":"info-card_description__3dvZN"};